import { render, staticRenderFns } from "./samrtSendOrder.vue?vue&type=template&id=65d68921&scoped=true&"
import script from "./samrtSendOrder.vue?vue&type=script&lang=js&"
export * from "./samrtSendOrder.vue?vue&type=script&lang=js&"
import style0 from "./samrtSendOrder.vue?vue&type=style&index=0&id=65d68921&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d68921",
  null
  
)

export default component.exports